import { render, staticRenderFns } from "./taxSummary.vue?vue&type=template&id=e4b55af0&"
import script from "./taxSummary.vue?vue&type=script&lang=js&"
export * from "./taxSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports